// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_ecq","cls2":"SimplePaperPodcast-cls2__ql SimplePaperPodcast-cls1_ecq"};